module.exports = __webpack_public_path__ + "img/ewm2.fcd30395.png";